import { IMithrilComponent } from '../../components/mithril.component';
import { addStyles } from '../../components/theme';
import { m } from '../../mithril';
import { Services } from '../../services';

export const CSS = {
	wrapper: 'c-StreetviewWrapper',
};

const Style = {
	[CSS.wrapper]: {
		height: '100%',
		width: '100%',
	},
};

addStyles(Style);

export class Streetview extends IMithrilComponent {
	panorama: google.maps.StreetViewPanorama | null = null;

	override onCreate(vnode) {
		this.panorama = Services.Streetview.attach(vnode.dom);
	}

	get nodes() {
		return m('div', {
			className: CSS.wrapper,
		});
	}
}
